export default {
      id: "i-logo-usage",
      viewBox: "0 0 793 121",
      url: __webpack_public_path__ + "img/sprite.svg#i-logo",
      toString: function () {
        return this.url;
      }
    }